import { Component } from '@angular/core';
import { FileUploadValidationErrors } from '@ca/core/models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'ca-file-upload-confirm-dialog',
    templateUrl: './file-upload-confirm-dialog.component.html',
    styleUrls: ['./file-upload-confirm-dialog.component.scss'],
})
export class FileUploadConfirmDialogComponent {
    validationErrors: FileUploadValidationErrors;
    hasSomeValidFiles = false;

    constructor(private activeModal: NgbActiveModal) {}

    closeModal(confirm: boolean): void {
        this.activeModal.close(confirm);
    }
}
